(function () {
  'use strict';

  function loadPlacesLibrary(apiKey) {
    if (window.__sdPlacesPromise) return window.__sdPlacesPromise;

    window.__sdPlacesPromise = new Promise(function (resolve, reject) {
      if (window.google && window.google.maps && window.google.maps.importLibrary) {
        window.google.maps.importLibrary('places').then(resolve, reject);
        return;
      }

      window.__sdInitMaps = function () {
        window.google.maps.importLibrary('places').then(resolve, reject);
      };

      var script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) +
        '&loading=async&callback=__sdInitMaps&v=weekly';
      script.async = true;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__sdPlacesPromise;
  }

  function extractPostalCode(place) {
    var components = place.addressComponents || [];
    for (var i = 0; i < components.length; i++) {
      if (components[i].types.indexOf('postal_code') !== -1) {
        return components[i].shortText || components[i].longText;
      }
    }
    return null;
  }

  function jsonFetch(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json();
    });
  }

  function initSection(root) {
    var appsScriptUrl = root.getAttribute('data-apps-script-url');
    var placesApiKey = root.getAttribute('data-places-api-key');
    var form = root.querySelector('[data-schedule-delivery-form]');
      var confirmCheckbox = root.querySelector('[data-help-confirm]');
      if (confirmCheckbox) {
        confirmCheckbox.addEventListener('change', function () {
          refreshSubmitAvailability();
        });
      }
    var addressMount = root.querySelector('[data-address-mount]');
    var addressStatus = root.querySelector('[data-address-status]');
    var promoInput = root.querySelector('[data-promo-input]');
    var promoStatus = root.querySelector('[data-promo-status]');
    var slotsWrapper = root.querySelector('[data-slots-wrapper]');
        var calendarList = root.querySelector('[data-calendar-list]');
    var timesWrapper = root.querySelector('[data-times-wrapper]');
    var selectedDateLabel = root.querySelector('[data-selected-date-label]');
    var slotsList = root.querySelector('[data-slots-list]');
    var submitBtn = root.querySelector('[data-submit-btn]');
    var formMessage = root.querySelector('[data-form-message]');
    var confirmation = root.querySelector('[data-confirmation]');
    var priceDisplay = root.querySelector('[data-price-display]');
    var basePriceCents = parseInt(root.getAttribute('data-product-price-value'), 10) || 0;
    var originalPriceHTML = priceDisplay ? priceDisplay.innerHTML : '';

    var state = {
      zip: null,
      formattedAddress: null,
      selectedSlot: null,
      zipAllowed: false,
      // [24HC tax summary 2026-10-26] filled from Google Places + backend quote (optional)
      address1: '',
      city: '',
      province: '',
      quote: null,
      quoteRequired: false, // becomes true only once the backend says taxEnabled
      idemKey: newKey()
    };

    function showMessage(text, isError) {
      formMessage.hidden = !text;
      formMessage.textContent = text || '';
      formMessage.style.color = isError ? '#b42318' : '#067647';
    }

    function setAddressStatus(text, stateName) {
      addressStatus.hidden = !text;
      addressStatus.textContent = text || '';
      addressStatus.setAttribute('data-state', stateName || '');
    }

    function setPromoStatus(text, stateName) {
      promoStatus.hidden = !text;
      promoStatus.textContent = text || '';
      promoStatus.setAttribute('data-state', stateName || '');
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    // ── [24HC tax summary 2026-10-26] subtotal / tax / total from the backend quote ──
    // Graceful fallback: if the backend has no 'quote' action (v23 answers
    // {error:'Unknown action'}) or returns taxEnabled:false, the summary stays hidden,
    // nothing is blocked and the form behaves exactly as before.
    function newKey() {
      return (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID()
        : 'k-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    }
    function componentsToAddress(place) {
      var out = { streetNumber: '', route: '', city: '', province: '', zip: '' };
      (place.addressComponents || []).forEach(function (c) {
        var t = c.types || [];
        if (t.indexOf('street_number') > -1) out.streetNumber = c.longText || '';
        if (t.indexOf('route') > -1) out.route = c.longText || '';
        if (t.indexOf('locality') > -1) out.city = c.longText || '';
        if (!out.city && t.indexOf('sublocality') > -1) out.city = c.longText || '';
        if (t.indexOf('administrative_area_level_1') > -1) out.province = c.shortText || '';
        if (t.indexOf('postal_code') > -1) out.zip = c.longText || c.shortText || '';
      });
      out.address1 = (out.streetNumber + ' ' + out.route).trim();
      return out;
    }
    var summary = root.querySelector('[data-order-summary]');
    function isNum(n) { return typeof n === 'number' && isFinite(n); }
    function money(n) { return '$' + Number(n).toFixed(2); }
    function setSummaryText(sel, text) {
      var el = summary && summary.querySelector(sel);
      if (el) el.textContent = text;
    }
    function setSummaryHidden(sel, hidden) {
      var el = summary && summary.querySelector(sel);
      if (el) el.hidden = hidden;
    }
    function hideSummary() { if (summary) summary.hidden = true; }
    function isTaxQuote(q) {
      return !!(q && q.success && q.taxEnabled === true && isNum(q.total) && isNum(q.tax) && isNum(q.subtotal));
    }
    function renderQuote(q) {
      // Only a real tax quote is shown; anything else keeps today's display.
      if (!summary || !isTaxQuote(q)) { hideSummary(); return; }
      var discount = isNum(q.discount) ? q.discount : 0;
      setSummaryText('[data-sum-subtotal]', money(q.subtotal + discount));
      setSummaryHidden('[data-sum-discount-row]', !(discount > 0));
      setSummaryText('[data-sum-discount]', '\u2212' + money(discount));
      setSummaryHidden('[data-sum-tax-row]', false);
      setSummaryText('[data-sum-tax]', money(q.tax));
      setSummaryText('[data-sum-total]', money(q.total));
      setSummaryHidden('[data-sum-note]', false);
      summary.hidden = false;
    }
    var quoteSeq = 0;
    function requestQuote() {
      state.quote = null;
      hideSummary();
      refreshSubmitAvailability();
      if (!state.zipAllowed || !state.address1 || !appsScriptUrl) return;
      var seq = ++quoteSeq;
      fetch(appsScriptUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          action: 'quote', variantId: currentVariantId(), address: state.formattedAddress,
          address1: state.address1, city: state.city, province: state.province, zip: state.zip,
          promoCode: promoInput.value.trim()
        })
      }).then(function (r) { return r.json(); }).then(function (q) {
        if (seq !== quoteSeq) return; // a newer quote is in flight
        if (q && q.success) {
          state.quote = q;
          state.quoteRequired = q.taxEnabled === true;
          renderQuote(q);
        } else if (q && q.code) {
          // Patched backend answered with a reason (bad_address, tax_quote_failed, rate_limited...)
          if (q.code === 'tax_quote_failed') state.quoteRequired = true;
          showMessage(q.error || 'Could not price this delivery.', true);
        }
        // else: old backend without a quote action -> silent fallback to today's display
        refreshSubmitAvailability();
      }).catch(function (err) {
        if (seq !== quoteSeq) return;
        if (state.quoteRequired) showMessage('Could not price this delivery. Please try again.', true);
        else console.warn('Schedule Delivery: quote unavailable, using standard display', err);
        refreshSubmitAvailability();
      });
    }

    function updatePriceDisplay(discounted) {
      if (!priceDisplay) return;
      if (discounted) {
        var discountedCents = Math.round(basePriceCents * 0.9);
        priceDisplay.innerHTML = '<s>' + formatMoney(basePriceCents) + '</s> ' + formatMoney(discountedCents);
      } else {
        priceDisplay.innerHTML = originalPriceHTML;
      }
    }

  function checkPromoCode(code) {
    if (!code) {
      setPromoStatus('', '');
      updatePriceDisplay(false);
      return;
    }
    jsonFetch(appsScriptUrl + '?action=checkPromo&code=' + encodeURIComponent(code)).then(function (data) {
      if (data && data.valid) {
        setPromoStatus('10% off applied - thanks for supporting ' + data.affiliateName + '!', 'allowed');
        updatePriceDisplay(true);
      } else {
        setPromoStatus('That code is not valid.', 'denied');
        updatePriceDisplay(false);
      }
    }).catch(function () {
      setPromoStatus('', '');
      updatePriceDisplay(false);
    });
  }

    promoInput.addEventListener('blur', function () {
      checkPromoCode(promoInput.value.trim());
      if (state.zipAllowed && state.address1) requestQuote(); // [24HC tax summary]
    });
function currentVariantId() {
      return root.getAttribute('data-variant-id');
    }

    // --- Meta Pixel: booking-form-interaction AddToCart signal (QA build, gated by section toggle) ---
    (function initAddToCartSignal() {
      var ATC_LOG = '[Schedule Delivery ATC Signal]';

      if (root.getAttribute('data-enable-atc-signal') !== 'true') {
        console.log(ATC_LOG, 'Disabled via section setting - skipping setup');
        return;
      }
      if (!form) {
        console.warn(ATC_LOG, 'Form not found - skipping setup');
        return;
      }

      var sessionKey = 'sd_atc_signal_fired:' + currentVariantId();
      var firedThisPageLoad = false;

      function hasAlreadyFiredThisSession() {
        try {
          return sessionStorage.getItem(sessionKey) === '1';
        } catch (e) {
          return false;
        }
      }

      function markFired() {
        firedThisPageLoad = true;
        try {
          sessionStorage.setItem(sessionKey, '1');
        } catch (e) {
          console.warn(ATC_LOG, 'sessionStorage unavailable, relying on in-memory flag only', e);
        }
      }

      function fireAddToCartSignal(evt) {
        if (firedThisPageLoad || hasAlreadyFiredThisSession()) return;
        markFired();
        form.removeEventListener('focusin', fireAddToCartSignal, true);
        form.removeEventListener('input', fireAddToCartSignal, true);

        console.log(ATC_LOG, 'First form interaction detected via', evt ? evt.type : 'unknown', '- preparing signal');

        if (typeof window.fbq !== 'function') {
          console.warn(ATC_LOG, 'window.fbq not found on this page - signal skipped');
          return;
        }

        var variantId = currentVariantId();
        var productTitle = root.getAttribute('data-product-title') || '';
        var priceCents = parseInt(root.getAttribute('data-product-price-value'), 10) || 0;
        var priceValue = Math.round((priceCents / 100) * 100) / 100;
        var currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

        var payload = {
          content_ids: [String(variantId)],
          content_type: 'product',
          content_name: productTitle,
          value: priceValue,
          currency: currencyCode
        };

        console.log(ATC_LOG, 'Firing fbq(track, AddToCart) with payload:', payload);
        try {
          window.fbq('track', 'AddToCart', payload);
          root.setAttribute('data-atc-signal-fired', 'true');
          console.log(ATC_LOG, 'fbq AddToCart fired successfully for variant', variantId);
        } catch (err) {
          console.error(ATC_LOG, 'fbq call threw an error', err);
        }
      }

      if (hasAlreadyFiredThisSession()) {
        console.log(ATC_LOG, 'Already fired this session for variant', currentVariantId(), '- not attaching listener');
      } else {
        form.addEventListener('focusin', fireAddToCartSignal, true);
        form.addEventListener('input', fireAddToCartSignal, true);
        console.log(ATC_LOG, 'Listener attached, waiting for first interaction on variant', currentVariantId());
      }
    })();

   function renderTimesForDay(day) {
      slotsList.innerHTML = '';
      state.selectedSlot = null;
      submitBtn.disabled = true;
      selectedDateLabel.textContent = day.label;
      timesWrapper.hidden = false;

      if (!day.slots.length) {
        var empty = document.createElement('p');
        empty.textContent = 'No delivery windows left for this day.';
        slotsList.appendChild(empty);
        return;
      }

      day.slots.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'schedule-delivery__slot-btn';
        btn.textContent = slot.label;
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(slotsList.children, function (child) {
            child.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('aria-pressed', 'true');
          state.selectedSlot = {
            date: day.date,
            slotStart: slot.slotStart,
            slotEnd: slot.slotEnd,
            label: slot.label
          };
          refreshSubmitAvailability();
        });
        slotsList.appendChild(btn);
      });
    }

    function refreshSubmitAvailability() {
      // [24HC tax summary] a quote is only required once the backend has said tax is on
      var quoteOk = !state.quoteRequired || isTaxQuote(state.quote);
      submitBtn.disabled = !(state.selectedSlot && quoteOk && confirmCheckbox && confirmCheckbox.checked);
    }

    function renderCalendar(days) {
      calendarList.innerHTML = '';
      slotsList.innerHTML = '';
      timesWrapper.hidden = true;
      state.selectedSlot = null;
      submitBtn.disabled = true;

      if (!days.length) {
        slotsWrapper.hidden = false;
        var empty = document.createElement('p');
        empty.textContent = 'No delivery windows are available in the next 7 days. Please check back soon.';
        calendarList.appendChild(empty);
        return;
      }

      slotsWrapper.hidden = false;

      days.forEach(function (day, index) {
        var hasSlots = !day.closed && day.slots.length > 0;

        var tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'schedule-delivery__date-btn';
        tile.setAttribute('aria-pressed', 'false');
        if (index === 0) tile.setAttribute('data-today', 'true');
        if (!hasSlots) tile.disabled = true;

        var weekday = document.createElement('span');
        weekday.className = 'schedule-delivery__date-weekday';
        weekday.textContent = day.weekday;
        tile.appendChild(weekday);

        var dateNum = document.createElement('span');
        dateNum.className = 'schedule-delivery__date-num';
        dateNum.textContent = day.dayNum;
        tile.appendChild(dateNum);

        if (index === 0) {
          var dot = document.createElement('span');
          dot.className = 'schedule-delivery__date-dot';
          tile.appendChild(dot);
        } else if (!hasSlots) {
          var status = document.createElement('span');
          status.className = 'schedule-delivery__date-status';
          // 24HC 2026-10-26: closed days (Sundays) say "Closed", not "Booked"; still not selectable.
          status.textContent = day.closed ? 'Closed' : 'Full';
          tile.appendChild(status);
        }
        if (day.closed) {
          var closedNote = /^sun/i.test(String(day.weekday || '')) ? 'No Sunday deliveries' : 'Closed - no deliveries this day';
          tile.title = closedNote;
          tile.setAttribute('aria-label', String(day.weekday || '') + ' ' + String(day.dayNum || '') + ': ' + closedNote);
        }

        tile.addEventListener('click', function () {
          Array.prototype.forEach.call(calendarList.children, function (child) {
            child.setAttribute('aria-pressed', 'false');
          });
          tile.setAttribute('aria-pressed', 'true');
          renderTimesForDay(day);
        });

        calendarList.appendChild(tile);
      });

      var firstAvailable = days.filter(function (day) {
        return !day.closed && day.slots.length > 0;
      })[0];
      if (firstAvailable) {
        var index = days.indexOf(firstAvailable);
        calendarList.children[index].setAttribute('aria-pressed', 'true');
        renderTimesForDay(firstAvailable);
      }
    }

    function fetchSlots() {
      return jsonFetch(appsScriptUrl + '?action=getSlots').then(function (data) {
var days = data.days || [];
renderCalendar(days);
      });
    }

    function handleZip(zip) {
      state.zip = zip;
      return jsonFetch(appsScriptUrl + '?action=checkZip&zip=' + encodeURIComponent(zip))
        .then(function (data) {
          state.zipAllowed = !!data.allowed;
          if (!data.allowed) {
            setAddressStatus('Sorry, we don\'t currently deliver to this address.', 'denied');
            slotsWrapper.hidden = true;
            submitBtn.disabled = true;
            return;
          }
          setAddressStatus('Great, we deliver to this address.', 'allowed');
          requestQuote(); // [24HC tax summary] runs alongside the slot lookup
          return fetchSlots();
        });
    }

    // [24HC speed 2026-10-26] Load Google Maps/Places after the page has loaded
    // and gone idle (or ~3.5s after load), or immediately if the shopper interacts
    // with the booking form or it scrolls near the viewport, whichever is first.
    // Runs once; the Places init below is unchanged.
    var placesStarted = false;
    var placesObserver = null;
    function startPlaces() {
      if (placesStarted) return;
      placesStarted = true;
      if (placesObserver) { placesObserver.disconnect(); placesObserver = null; }
      ['focusin', 'pointerdown', 'touchstart', 'keydown'].forEach(function (type) {
        root.removeEventListener(type, startPlaces, true);
      });
      initPlaces();
    }
    ['focusin', 'pointerdown', 'touchstart', 'keydown'].forEach(function (type) {
      root.addEventListener(type, startPlaces, { capture: true, passive: true });
    });
    // Background load once the page has settled: requestIdleCallback after the
    // load event, with a ~3.5s fallback timer, whichever comes first.
    function scheduleIdlePlaces() {
      if (placesStarted) return;
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(startPlaces, { timeout: 3500 });
      }
      setTimeout(startPlaces, 3500);
    }
    if (document.readyState === 'complete') {
      scheduleIdlePlaces();
    } else {
      window.addEventListener('load', scheduleIdlePlaces, { once: true });
    }
    if ('IntersectionObserver' in window) {
      placesObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { startPlaces(); return; }
        }
      }, { rootMargin: '200px 0px 200px 0px' });
      placesObserver.observe(addressMount || root);
    } else {
      startPlaces();
    }

    function initPlaces() {
    loadPlacesLibrary(placesApiKey).then(function (placesLib) {
      var autocomplete = new placesLib.PlaceAutocompleteElement({
        includedRegionCodes: ['us']
      });
      addressMount.appendChild(autocomplete);
      autocomplete.style.setProperty('color-scheme', 'light');
      autocomplete.style.setProperty('background-color', '#ffffff');
      autocomplete.style.setProperty('border', '1px solid rgba(0,0,0,0.2)');
      autocomplete.style.setProperty('border-radius', '0.4rem');

      autocomplete.addEventListener('gmp-select', function (event) {
        var prediction = event.placePrediction;
        var place = prediction.toPlace();
        place.fetchFields({ fields: ['addressComponents', 'formattedAddress'] }).then(function () {
          state.formattedAddress = place.formattedAddress;
          // [24HC tax summary] keep street / city / state for the quote and the booking
          var parts = componentsToAddress(place);
          state.address1 = parts.address1;
          state.city = parts.city;
          state.province = parts.province;
          state.quote = null;
          hideSummary();
          if (parts.province && parts.province !== 'CO') {
            state.zipAllowed = false;
            slotsWrapper.hidden = true;
            submitBtn.disabled = true;
            setAddressStatus('We only deliver in Colorado.', 'denied');
            return;
          }
          var zip = extractPostalCode(place);
          if (!zip) {
            setAddressStatus('Could not determine a zip code for that address.', 'denied');
            return;
          }
          handleZip(zip);
        });
      });
    }).catch(function (err) {
      setAddressStatus('Address lookup is temporarily unavailable.', 'denied');
      console.error('Schedule Delivery: failed to load Places library', err);
    });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!confirmCheckbox || !confirmCheckbox.checked) {
        showMessage('Please confirm someone will be home to help the driver carry the couch inside.', true);
        return;
      }

      if (!state.zipAllowed || !state.selectedSlot || !state.formattedAddress) {
        showMessage('Please enter a deliverable address and choose a delivery window.', true);
        return;
      }

      var fullNameParts = form.fullName.value.trim().split(/\s+/);
      var payload = {
        action: 'book',
        firstName: fullNameParts.shift() || '',
        lastName: fullNameParts.join(' '),
        email: form.email.value.trim(),
        phone: form.phone.value.trim(),
        address: state.formattedAddress,
        zip: state.zip,
        deliveryDate: state.selectedSlot.date,
        slotStart: state.selectedSlot.slotStart,
        slotEnd: state.selectedSlot.slotEnd,
        variantId: currentVariantId(),
        productTitle: root.getAttribute('data-product-title'),
        price: root.getAttribute('data-product-price'),
        promoCode: promoInput.value.trim(),
        helpConfirmed: true,
        // [24HC tax summary] extra fields; the current backend (v23) ignores them
        address1: state.address1,
        city: state.city,
        province: state.province,
        idempotencyKey: state.idemKey
      };
      if (state.quote && isNum(state.quote.total)) payload.quotedTotal = state.quote.total;

      submitBtn.disabled = true;
      submitBtn.textContent = 'Scheduling\u2026';
      showMessage('', false);

      fetch(appsScriptUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (!data.success) {
          if (data.error === 'slot_taken') {
      showMessage('That window was just booked by someone else — please pick another.', true);
      state.idemKey = newKey(); // [24HC tax summary] new attempt = new key
      fetchSlots();
      refreshSubmitAvailability();
      submitBtn.textContent = 'Schedule Delivery';
    } else if (data.error === 'sold_out') {
      form.hidden = true;
      confirmation.hidden = false;
      confirmation.style.background = '#fef3f2';
      confirmation.style.color = '#b42318';
      confirmation.textContent = 'Sorry — this couch was just scheduled for delivery by another customer and is no longer available.';
    } else if (data.code === 'price_changed' && data.quote) {
      // [24HC tax summary] total moved since the quote: show the new one, ask again
      state.quote = data.quote;
      state.quoteRequired = data.quote.taxEnabled === true;
      renderQuote(data.quote);
      showMessage(data.error || 'The total changed. Please check it and confirm again.', true);
      refreshSubmitAvailability();
      submitBtn.textContent = 'Confirm new total';
    } else if (data.code === 'in_progress') {
      showMessage(data.error || 'Your booking is already being processed.', true); // keep button disabled
    } else {
      showMessage(data.error || 'Something went wrong. Please try again.', true);
      refreshSubmitAvailability();
      submitBtn.textContent = 'Schedule Delivery';
    }
    return;
        }

        form.hidden = true;
        confirmation.hidden = false;
        confirmation.textContent = 'Order ' + data.orderName + ' confirmed \u2014 delivery scheduled ' +
          data.deliveryDate + ', ' + data.slotLabel +
                                  '. Your driver will collect payment at delivery. They\'ll text you when they\'re on the way.' +
            (data.discountApplied ? ' 10% off applied \u2014 thanks for using code ' + promoInput.value.trim().toUpperCase() + '!' : '') +
            // [24HC tax summary] only when the backend charged tax
            (data.taxEnabled && isNum(data.total) ? ' Total due at delivery: ' + money(data.total) +
              (isNum(data.tax) ? ' (includes ' + money(data.tax) + ' sales tax).' : '.') : '');
        state.idemKey = newKey(); // [24HC tax summary]
      }).catch(function (err) {
        console.error('Schedule Delivery: booking failed', err);
        showMessage('Something went wrong. Please try again.', true);
        refreshSubmitAvailability();
        submitBtn.textContent = 'Schedule Delivery';
      });
    });
  }

  function initDesktopGalleryClickToAdvance() {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  document.querySelectorAll('media-gallery slideshow-slide[on\\:click*="/open/"]').forEach(function (slide) {
    slide.removeAttribute('on:click');
    slide.addEventListener('click', function () {
      var gallery = slide.closest('media-gallery');
      var nextBtn = gallery && gallery.querySelector('.slideshow-control--next');
      if (nextBtn) { nextBtn.click(); }
    });
  });
}

function init() {
    document.querySelectorAll('[data-schedule-delivery]').forEach(initSection);
    initDesktopGalleryClickToAdvance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
